<template>
    <b-row>
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <b-card class="sa-card sa-card-border" header="Bisogni socio-assistenziali" header-tag="header" footer-tag="footer" title="">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data"> Motivo della richiesta di ricovero:</label>
                        <span v-if="isReadOnly">{{ jsonDataBisognoSocioAssistenziale.motivoRichiestaRicovero }}</span>
                        <b-form-textarea v-else v-model="jsonDataBisognoSocioAssistenziale.motivoRichiestaRicovero" :readonly="isReadOnly" max-rows="10" rows="7"></b-form-textarea>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data"> Aspettative utente:</label>
                        <span v-if="isReadOnly">{{ jsonDataBisognoSocioAssistenziale.aspettativeUtente }}</span>
                        <b-form-textarea v-else v-model="jsonDataBisognoSocioAssistenziale.aspettativeUtente" :readonly="isReadOnly" max-rows="10" rows="7"></b-form-textarea>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data"> Aspettative dei familiari/parenti:</label>
                        <span v-if="isReadOnly">{{ jsonDataBisognoSocioAssistenziale.aspettativeFamiliariParenti }}</span>
                        <b-form-textarea v-else v-model="jsonDataBisognoSocioAssistenziale.aspettativeFamiliariParenti" :readonly="isReadOnly" max-rows="10" rows="7"></b-form-textarea>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data"> Rapporto con i figli e tra gli stessi:</label>
                        <span v-if="isReadOnly">{{ jsonDataBisognoSocioAssistenziale.rapportoFigli }}</span>
                        <b-form-textarea v-else v-model="jsonDataBisognoSocioAssistenziale.rapportoFigli" :readonly="isReadOnly" max-rows="10" rows="7"></b-form-textarea>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data"> Figure significative (anche vicini, volontariato se disponibile a collaborare con la struttura):</label>
                        <span v-if="isReadOnly">{{ jsonDataBisognoSocioAssistenziale.figureSignificative }}</span>
                        <b-form-textarea v-else v-model="jsonDataBisognoSocioAssistenziale.figureSignificative" :readonly="isReadOnly" max-rows="10" rows="7"></b-form-textarea>
                    </b-col>
                </b-row>
            </b-card>
            <b-card class="sa-card sa-card-border" header="Cenni di anamnesi psico-sociale" header-tag="header" footer-tag="footer" title="">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data"> Storia Personale:</label>
                        <span v-if="isReadOnly">{{ jsonDataBisognoSocioAssistenziale.cenniAnamnesiPsicosociale }}</span>
                        <b-form-textarea v-else v-model="jsonDataBisognoSocioAssistenziale.cenniAnamnesiPsicosociale" :readonly="isReadOnly" max-rows="10" rows="7"></b-form-textarea>
                    </b-col>
                </b-row>
            </b-card>
            <b-card class="sa-card sa-card-border" header="Interventi e servizi" header-tag="header" footer-tag="footer" title="">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data"> Assistenza tutelare:( non autosuff./suff/autosufficiente)</label>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Igiene della persona: <span style="color: red">*</span></label>
                        <span v-if="isReadOnly">{{ jsonDataBisognoSocioAssistenziale.igienePersona }}</span>
                        <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonDataBisognoSocioAssistenziale.igienePersona" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Bagno: <span style="color: red">*</span></label>
                        <span v-if="isReadOnly">{{ jsonDataBisognoSocioAssistenziale.bagno }}</span>
                        <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonDataBisognoSocioAssistenziale.bagno" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Vestire: <span style="color: red">*</span></label>
                        <span v-if="isReadOnly">{{ jsonDataBisognoSocioAssistenziale.vestire }}</span>
                        <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonDataBisognoSocioAssistenziale.vestire" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Mangiare (imboccare): <span style="color: red">*</span></label>
                        <span v-if="isReadOnly">{{ jsonDataBisognoSocioAssistenziale.mangiare }}</span>
                        <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonDataBisognoSocioAssistenziale.mangiare" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Accompagnamento al wc (indicare uso di padella o pannoloni): <span style="color: red">*</span></label>
                        <span v-if="isReadOnly">{{ jsonDataBisognoSocioAssistenziale.accompagnamentoBagno }}</span>
                        <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonDataBisognoSocioAssistenziale.accompagnamentoBagno" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Aiuto nella deambulazione: <span style="color: red">*</span></label>
                        <span v-if="isReadOnly">{{ jsonDataBisognoSocioAssistenziale.aiutoDeambulazione }}</span>
                        <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonDataBisognoSocioAssistenziale.aiutoDeambulazione" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    props: {
        idRisorsa: {
            type: String,
            default: function () {
                return null;
            },
        },
        idAccettazione: {
            type: String,
            default: function () {
                return null;
            },
        },
        isReadOnly: {
            type: Boolean,
        },
    },

    data() {
        return {
            pathResourceBisognoSocioAssistenziale: "/rsaschedavalutazionebisognisocioassistenziali",
            jsonDataBisognoSocioAssistenziale: {
                idAccettazione: null,
                motivoRichiestaRicovero: null,
                aspettativeUtente: null,
                aspettativeFamiliariParenti: null,
                rapportoFigli: null,
                figureSignificative: null,
                igienePersona: null,
                bagno: null,
                vestire: null,
                mangiare: null,
                accompagnamentoBagno: null,
                aiutoDeambulazione: null,
            },
            sinoOptions: [
                { value: null, text: "Seleziona valore", disabled: true },
                { value: "SI", text: "SI" },
                { value: "NO", text: "NO" },
            ],
        };
    },

    mounted() {
        let me = this;
        me.idAccettazione = me.$route.query.idAccettazione ? me.$route.query.idAccettazione : me.$query.params.id;
        me.jsonData = { idAccettazione: me.idAccettazione };
        if (me.idRisorsa !== null) {
            me.visualizzaBisognoSocioAssistenziale();
        }
        me.jsonDataBisognoSocioAssistenziale = {
            idAccettazione: me.idAccettazione,
            motivoRichiestaRicovero: null,
            aspettativeUtente: null,
            aspettativeFamiliariParenti: null,
            rapportoFigli: null,
            figureSignificative: null,
            igienePersona: null,
            bagno: null,
            vestire: null,
            mangiare: null,
            accompagnamentoBagno: null,
            aiutoDeambulazione: null,
        };
    },

    watch: {
        jsonDataBisognoSocioAssistenziale: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },

    methods: {
        visualizzaBisognoSocioAssistenziale() {
            let me = this;
            let path = process.env.VUE_APP_PATH_API + me.pathResourceBisognoSocioAssistenziale + "/" + me.idRisorsa;
            UtilityMixin.methods.restCallGet(path, null, me.loadDataBisognoSocioAssistenzialeSuccess, me.loadDataBisognoSocioAssistenzialeError);
        },
        loadDataBisognoSocioAssistenzialeSuccess(response) {
            let me = this;
            me.jsonDataBisognoSocioAssistenziale = response.data.data;
        },
        loadDataBisognoSocioAssistenzialeError(error) {
            let me = this;
            me.$emit("afterLoadData", error);
            me.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
    },
};
</script>
